import { Module } from "vuex-smart-module"

import FeaturesState from "./state"
import FeaturesMutations from "./mutations";
import FeaturesGetters from "./getters";
import FeaturesActions from "./actions"

export const featuresModule = new Module({
    state: FeaturesState,
    getters: FeaturesGetters,
    mutations: FeaturesMutations,
    actions: FeaturesActions
})